import { ViewList, ViewModule } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

interface ViewModeButtonGroupProps<T> {
  view: T;
  handleChange: (event: React.MouseEvent<HTMLElement>, newView: T) => void;
}

export const ViewModeButtonGroup = <T extends string>({
  view,
  handleChange
}: ViewModeButtonGroupProps<T>) => {
  return (
    <ToggleButtonGroup value={view} exclusive onChange={handleChange}>
      <ToggleButton value="tiles" aria-label="tiles" size="small">
        <ViewModule />
      </ToggleButton>
      <ToggleButton value="list" aria-label="list" size="small">
        <ViewList />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
